
import axios from "axios";
import { getCurrentLanguage } from "../../../utils/languageStore";

const API = "https://zad_en.test/api/v1";
const APISERVER = "https://dashboard.khzad.org/api/v1"; 
export const api = axios.create({
  baseURL: APISERVER,
  // baseURL: API,

  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json",
    "Access-Control-Allow-Origin": "*",
    "X-API-KEY": "api!!!KEyZadGDe@@$$$vLarIv3sdflaw",
  },

});
api.interceptors.request.use((config) => {
  config.params = {
    ...config.params,
    lang: getCurrentLanguage(),
  };

  return config;
});


const APIDatabaseServer = "https://zadsystem.zadorg.site/api/v1"; 
export const apiDatabase = axios.create({
  baseURL: APIDatabaseServer,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "X-API-KEY": "zad",
  },

});